@if (contentEdit && item) {
  @if (showBackgroundPicker) {
    <div class="spacing-elements">
      <coin-color-picker [(ngModel)]="item.backgroundColor"></coin-color-picker>
    </div>
  }
  <coin-email-slider
    label="Space-Top"
    [(ngModel)]="item.paddingTop"></coin-email-slider>
  <coin-email-slider
    label="Space-Bottom"
    [(ngModel)]="item.paddingBottom"></coin-email-slider>
}

<div class="wrapper">
  <video
    controls
    [src]="item.link"
    [style.height]="item.height ? item.height + 'px' : defaultHeight"></video>

  @if (contentEdit) {
    <div class="options">
      <coin-v2-button
        type="secondary"
        icon="edit"
        [iconPos]="'right'"
        [text]="'cms.emails.change-video-button' | translate"
        (click)="editVideo()"></coin-v2-button>
      <coin-v2-number-input
        [label]="'cms.content-pages.video-height' | translate"
        [placeholder]="defaultHeight"
        [step]="1"
        [(ngModel)]="item.height"></coin-v2-number-input>
    </div>
  }
</div>
